module.exports = __webpack_public_path__ + "media/images/home/book_icon-63f2f8a88f96a0f735a43c3f064e0c0e.svg";